import * as cookie from 'js/lib/cookie';

import localStorageEx from 'bundles/common/utils/localStorageEx';

/**
 * Extract user email from _ue cookie and delete it immediately.
 * This is used to prefill the email field in the login form when the user is redirected with SSO error.
 *
 * @returns The user email from the cookie or undefined if the cookie is not found.
 */
export const getUserEmailFromCookie = (): string | undefined => {
  const cookieName = '_ue';
  const userEmail = cookie.get(cookieName);

  if (userEmail) {
    // Delete the cookie immediately after reading
    cookie.remove(cookieName);
    return userEmail;
  }

  return undefined;
};

// For automation tests like E2E, we need to bypass the bot manager flow, except for test cases that include Arkose.
export const shouldBypassBotManagerForAutomationTest = () =>
  localStorageEx.getItem('shouldBypassBotManager', Boolean, false);
